// AuditIQ — Enterprise Athletic Operations API client (Iter 19).
// Wraps the 70+ endpoints exposed by /app/backend/enterprise_ops.py.
import { api } from "./api";

const get = (p, params) => api.get(p, { params }).then((r) => r.data);
const post = (p, body) => api.post(p, body).then((r) => r.data);
const put = (p, body) => api.put(p, body).then((r) => r.data);
const del = (p, params) => api.delete(p, { params }).then((r) => r.data);

// =================================================================== overview
export const enterpriseApi = {
  overview: () => get("/enterprise/overview"),
  seed: () => post("/enterprise/seed"),
};

// ===================================================================== §1
export const messagingApi = {
  send: (body) => post("/messages/send", body),
  history: (thread_id) => get("/messages/history", thread_id ? { thread_id } : null),
  pushNotify: (athlete_id, title, body_text) =>
    post(`/notifications/push?athlete_id=${encodeURIComponent(athlete_id)}&title=${encodeURIComponent(title)}&body_text=${encodeURIComponent(body_text)}`),
  prefsGet: () => get("/notifications/preferences"),
  prefsSet: (prefs) => put("/notifications/preferences", prefs),
};

// ===================================================================== §2
export const schedulingApi = {
  list: (team_id) => get("/schedule", team_id ? { team_id } : null),
  conflicts: () => get("/schedule/conflicts"),
  create: (body) => post("/schedule/create", body),
  cancel: (event_id) => del(`/schedule/cancel?event_id=${encodeURIComponent(event_id)}`),
  attendanceRecord: (body) => post("/attendance/record", body),
  attendanceReport: (team_id) => get("/attendance/report", team_id ? { team_id } : null),
  facilities: () => get("/facilities"),
};

// ===================================================================== §3
export const medicalApi = {
  injuryReport: (body) => post("/injury/report", body),
  injuryStatus: (athlete_id) => get("/injury/status", { athlete_id }),
  rehabUpdate: (body) => post("/rehab/update", body),
  rehabClearance: (body) => post("/rehab/clearance", body),
  injuryHistory: (athlete_id) => get("/injury/history", { athlete_id }),
};

// ===================================================================== §4
export const performanceApi = {
  metrics: (athlete_id) => get("/performance/metrics", { athlete_id }),
  update: (body) => post("/performance/update", body),
  history: (athlete_id) => get("/performance/history", { athlete_id }),
  trend: (athlete_id) => get("/performance/trend", { athlete_id }),
};

// ===================================================================== §5
export const wearableApi = {
  connect: (body) => post("/device/connect", body),
  disconnect: (device_id) => del(`/device/disconnect?device_id=${encodeURIComponent(device_id)}`),
  sync: (device_id) => post(`/device/sync?device_id=${encodeURIComponent(device_id)}`),
  data: (athlete_id) => get("/device/data", { athlete_id }),
  status: (athlete_id) => get("/device/status", athlete_id ? { athlete_id } : null),
};

// ===================================================================== §6
export const complianceApi = {
  status: (athlete_id) => get("/compliance/status", athlete_id ? { athlete_id } : null),
  update: (body) => post("/compliance/update", body),
  nilList: () => get("/compliance/nil"),
  nilSubmit: (body) => post("/compliance/nil/submit", body),
  eligibility: (athlete_id) => get("/compliance/eligibility", athlete_id ? { athlete_id } : null),
  deadlines: () => get("/compliance/deadlines"),
};

// ===================================================================== §7
export const documentsApi = {
  upload: (body) => post("/documents/upload", body),
  list: (athlete_id) => get("/documents/list", athlete_id ? { athlete_id } : null),
  detail: (document_id) => get("/documents/detail", { document_id }),
  approve: (body) => post("/documents/approve", body),
  sign: (body) => post("/documents/sign", body),
  audit: (document_id) => get("/documents/audit", { document_id }),
};

// ===================================================================== §8
export const portalApi = {
  dashboard: () => get("/portal/dashboard"),
  schedule: () => get("/portal/schedule"),
  performance: () => get("/portal/performance"),
  healthSummary: () => get("/portal/health-summary"),
  formsUpload: (body) => post("/portal/forms/upload", body),
  parentVerify: (body) => post("/portal/parent/verify", body),
};

// ===================================================================== §9
export const alertsEntApi = {
  list: (severity) => get("/enterprise/alerts", severity ? { severity } : null),
  ack: (alert_id) => post("/enterprise/alerts/acknowledge", { alert_id }),
  clear: () => post("/enterprise/alerts/clear"),
  history: () => get("/enterprise/alerts/history"),
};

// ==================================================================== §10
export const reportsEntApi = {
  generate: (report_type) => get("/enterprise/reports/generate", { report_type }),
  schedule: (body) => post("/enterprise/reports/schedule", body),
  history: () => get("/enterprise/reports/history"),
  download: (report_id) => get("/enterprise/reports/download", { report_id }),
};

// ==================================================================== §12
export const tasksApi = {
  list: () => get("/tasks"),
  create: (body) => post("/tasks/create", body),
  update: (body) => put("/tasks/update", body),
  approve: (task_id) => post(`/tasks/approve?task_id=${encodeURIComponent(task_id)}`),
  overdue: () => get("/tasks/overdue"),
};

// ==================================================================== §13
export const integrationApi = {
  connect: (body) => post("/integration/connect", body),
  status: () => get("/integration/status"),
  sync: (integration_id) => post(`/integration/sync?integration_id=${encodeURIComponent(integration_id)}`),
  disconnect: (integration_id) => del(`/integration/disconnect?integration_id=${encodeURIComponent(integration_id)}`),
  logs: (integration_id) => get("/integration/logs", integration_id ? { integration_id } : null),
};

// ==================================================================== §14
export const auditEntApi = {
  logs: (filters = {}) => get("/audit/logs", filters),
  exportCsv: () => get("/audit/logs/export"),
};
